import type { Address } from '@nvd/claim-shared';
import { UI } from '../lib/ui';

export const EMPTY_ADDRESS: Address = {
  firstName: '',
  lastName: '',
  address1: '',
  address2: '',
  city: '',
  province: '',
  provinceCode: '',
  country: '',
  countryCode: '',
  zip: '',
  phone: '',
};

export function isAddressComplete(address: Address): boolean {
  return Boolean(address.lastName.trim() && address.address1.trim() && address.city.trim() && /^[A-Z]{2}$/.test(address.countryCode));
}

type Field = keyof typeof UI.address;

const FIELDS: ReadonlyArray<{ name: Field; required?: boolean; autoComplete: string; wide?: boolean }> = [
  { name: 'firstName', autoComplete: 'given-name' },
  { name: 'lastName', required: true, autoComplete: 'family-name' },
  { name: 'address1', required: true, autoComplete: 'address-line1', wide: true },
  { name: 'address2', autoComplete: 'address-line2', wide: true },
  { name: 'city', required: true, autoComplete: 'address-level2' },
  { name: 'province', autoComplete: 'address-level1' },
  { name: 'zip', autoComplete: 'postal-code' },
  { name: 'countryCode', required: true, autoComplete: 'country' },
  { name: 'phone', autoComplete: 'tel', wide: true },
];

export function AddressForm({ value, onChange }: { value: Address; onChange: (address: Address) => void }) {
  const update = (name: Field, text: string) => {
    const next = { ...value, [name]: name === 'countryCode' ? text.toUpperCase().slice(0, 2) : text };
    if (name === 'province') next.provinceCode = '';
    if (name === 'countryCode' && text.toUpperCase() !== value.countryCode) next.country = '';
    onChange(next);
  };

  return (
    <div className="nvd-claim-portal__address">
      {FIELDS.map(({ name, required, autoComplete, wide }) => (
        <label key={name} className={`nvd-claim-portal__field${wide ? ' nvd-claim-portal__field--wide' : ''}`}>
          <span className="nvd-claim-portal__label">
            {UI.address[name]}
            {required && <span className="nvd-claim-portal__required"> *</span>}
          </span>
          <input
            className="nvd-claim-portal__input"
            value={value[name]}
            required={required}
            autoComplete={autoComplete}
            onChange={(event) => update(name, event.target.value)}
          />
        </label>
      ))}
    </div>
  );
}
